"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDynamicScript = void 0;

var tslib_1 = require("tslib");

var react_1 = require("react");

var useDynamicScript = function useDynamicScript(remoteUrl) {
  var _a = tslib_1.__read((0, react_1.useState)(false), 2),
      ready = _a[0],
      setReady = _a[1];

  var _b = tslib_1.__read((0, react_1.useState)(false), 2),
      failed = _b[0],
      setFailed = _b[1];

  (0, react_1.useEffect)(function () {
    if (!remoteUrl) {
      return;
    }

    var element = document.createElement('script');
    element.src = remoteUrl;
    element.type = 'text/javascript';
    element.async = true;
    setReady(false);
    setFailed(false);

    element.onload = function () {
      setReady(true);
    };

    element.onerror = function () {
      setReady(false);
      setFailed(true);
    };

    document.head.appendChild(element);
    return function () {
      document.head.removeChild(element);
    };
  }, [remoteUrl]);
  return {
    ready: ready,
    failed: failed
  };
};

exports.useDynamicScript = useDynamicScript;